// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Header_navbar__1pLRI","navLink":"Header_navLink__1im2i","navTitle":"Header_navTitle__1FPqp"};